import type { LineItemSettingsKey } from '@frontend/api';

export const getLineItemSettingsKey = (): LineItemSettingsKey => [
  'suppliers',
  'lineItemSettings',
];
